var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guidance"},[_vm._m(0),_c('div',{staticClass:"my-4"}),_c('SurveyPartsabSummarySubguidance'),_c('SurveyWhenToSignUpSubguidance'),_c('SurveyHowToSignUpPartsabSubguidance'),_c('SurveyWatchOutForSubguidance'),_c('SurveyGettingCoverageAfterMedicareSubguidance')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_c('span',[_vm._v("Your Medicare Eligibility")])])
}]

export { render, staticRenderFns }